require('./bootstrap');

import $ from 'jquery';
import 'bootstrap';
import 'select2';

window.$ = window.jQuery = $;

require('bootstrap-validator');
require('jquery.dirty');
require('owl.carousel');
window.datetimepicker = require('bootstrap4-datetimepicker');
window.WorkerTimer = require("worker-timer");
// window.ClassicEditor = require("@ckeditor/ckeditor5-build-classic");
// window.SpecialCharacters from '@ckeditor/ckeditor5-special-characters';

// window.http = require('http')
// var Cookies = require('cookies');

import Alpine from 'alpinejs';
import swal from 'sweetalert';
import moment from 'moment';
import 'moment-timezone';
import Dropzone from "dropzone";

window.Alpine = Alpine;
window.moment = moment;

Alpine.start();

// import './actions.js';
